// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';

import StyledForm from '../shared/StyledForm';
import Scrollable from '../shared/Scrollable';

import Button from '../shared/Button';
import Select from '../shared/forms/Select';
import TextArea from '../shared/forms/TextArea';
import TextInput from '../shared/forms/TextInput';
import NumericInput from '../shared/forms/NumericInput';

export const validate = (values: Object) => {
    const errors = {};

    if (!values.localAuthority || values.localAuthority.length < 1) {
        errors.localAuthority = 'Please specify the local authority';
    }

    return errors;
};

let PropertyCostsForm = props => {
    const {
        handleSubmit,
        dirty,
        submitting,
        propertyPromotionOptions,
        selectedPromotionType,
        standardText,
    } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <Prompt
                when={dirty && !submitting}
                message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
            />

            <Scrollable additionalClassName="scroll-area">
                <div className="flex">
                    <div className="col">
                        <Field
                            name="localAuthority"
                            label="Local Authority"
                            component={TextInput}
                            disabled={submitting}
                        />

                        <Field
                            name="deposit"
                            label="Deposit"
                            placeholder={standardText.defaultTextItems.deposit}
                            component={TextInput}
                            disabled={submitting}
                        />

                        <Field
                            name="costs"
                            label="Costs"
                            placeholder={standardText.defaultTextItems.costs}
                            component={TextArea}
                        />

                        <Field
                            name="businessRates"
                            label="Business Rates"
                            placeholder={standardText.defaultTextItems.rates}
                            component={TextArea}
                            disabled={submitting}
                        />
                    </div>

                    <div className="col">
                        <Field
                            name="promotionType"
                            label="Promotion Type"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            {propertyPromotionOptions.map(option =>
                                <option key={option.id} value={option.id}>
                                    {option.label}
                                </option>
                            )}
                        </Field>

                        <Field
                            name="promotionAfterPrice"
                            label="After Price"
                            prefix="£"
                            component={NumericInput}
                            disabled={submitting}
                        />

                        {selectedPromotionType &&
                            selectedPromotionType.indexOf('RENT_FREE_MONTHS') >
                                -1 &&
                            <Field
                                name="rentFreeMonths"
                                label="Rent Free Months"
                                suffix="months"
                                component={NumericInput}
                                disabled={submitting}
                            />}
                    </div>
                </div>
            </Scrollable>

            <div className="sticky-footer">
                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save & Continue'}
                </Button>
            </div>
        </StyledForm>
    );
};

PropertyCostsForm = reduxForm({
    form: 'propertyEditCosts',
    validate,
})(PropertyCostsForm);

const selector = formValueSelector('propertyEditCosts');

const mapStateToProps = state => {
    return {
        selectedPromotionType: selector(state, 'promotionType'),
    };
};

export default connect(mapStateToProps)(PropertyCostsForm);



// WEBPACK FOOTER //
// ./src/components/PropertyForms/PropertyCostsForm.js